<p-dialog
  header="Select Queue"
  [style]="{ width: '500px' }"
  [modal]="true"
  [closable]="true"
  [draggable]="true"
  [(visible)]="isVisible"
  (visibleChange)="onClose()"
>
  <div class="queue-modal">
    <p-listbox
      styleClass="current-user mb-6"
      data-test-id="current-user-box"
      [options]="currentUser"
      [ngModel]="selectedUserId"
      (onChange)="selectedUserId = $event.value"
    >
    </p-listbox>
    <p-listbox
      styleClass="queue-search"
      data-test-id="users-listbox"
      emptyMessage="Loading..."
      filterPlaceHolder="Search"
      filterBy="label"
      optionLabel="label"
      optionValue="value"
      [filter]="true"
      [options]="users"
      [ngModel]="selectedUserId"
      (onChange)="selectedUserId = $event.value"
    >
    </p-listbox>
  </div>
  <div class="flex justify-end mt-4">
    <button
      pButton
      severity="info"
      type="button"
      label="Close"
      class="mr-2"
      data-test-id="route-to-queue-cancel-button"
      (click)="onClose()"
    ></button>
    <button
      pButton
      type="button"
      label="Submit"
      data-test-id="route-to-queue-button"
      [loading]="isLoading"
      [disabled]="!selectedUserId"
      (click)="onSubmit()"
    ></button>
  </div>
</p-dialog>
